import Thumbnails from "../Icons/Thumbnails";

export default function ImagePanel({imgSrc, path,onClick}) {
    return (
        <div className="h-full overflow-auto p-4">
            <div className="grid grid-cols-6 gap-y-6 gap-x-4">

                {imgSrc.map((image) => (
                    <Thumbnails
                    imgSource={`https://ik.imagekit.io/badu01/${path}/${image.src}`}
                    name={image.title}
                    key={image.src}
                    onClick={onClick}
                    />
                ))}

            </div>
        </div>
    );
}